import './index.scss';
import React, {useEffect, useRef} from 'react';
import {ReactComponent as LogoS} from '../../../assets/images/portfolio.svg';
import gsap from 'gsap-trial'
import DrawSVGPlugin from 'gsap-trial/DrawSVGPlugin'

export const Logo = () => {
    const bgRef = useRef()
    const outlineLogoRef = useRef()
    const solidLogoRef = useRef()

    // useEffect(() => {
    //     gsap.registerPlugin(DrawSVGPlugin)

    //     gsap.timeline()
    //     toString(bgRef.current, {
    //         duration: 1,
    //         opacity: 1
    //     })
    //         .from(outlineLogoRef.current, {
    //             drawSVG: 0,
    //             duration: 20,

    //         })

    //     gsap.fromTo(
    //         solidLogoRef.current,
    //         {
    //             opacity: 0,
    //         },
    //         {
    //             opacity: 1,
    //             delay: 4,
    //             duration: 4
    //         }
    //     )
    // }, [])
    useEffect(() => {
        console.log(solidLogoRef)
    }, []);
    return (
        <div className="logo-container" ref={bgRef}>
            {/*<img ref={solidLogoRef} className="solid-logo" src={LogoS} alt="S" />*/}
            <LogoS ref={solidLogoRef} className={'solid-logo'}/>
        </div>
    )
}
